module.exports = __webpack_public_path__ + "img/monitor-waveform.14d3f690.svg";